import { Component, inject } from '@angular/core';
import { ListViewProviderDirective } from '@ntap/core';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { map } from 'rxjs';

@Component({
  selector: 'app-set-status-otpreme',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class SetStatusOtpremeActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  listViewProvider = inject(ListViewProviderDirective);

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedItems) => {
        return selectedItems.length < 1;
      })
    );
  }
}
